export const CustomerTypes = {
  content: [{ id: 'LEGAL' }, { id: 'INDIVIDUAL' }, { id: 'MOBILE' }],
  loading: false,
  error: false,
};
